import React, { useEffect, useState } from "react";
import { trackButtonClick } from "../analytics/ga";
import { CHROME_EXTENSION_URL } from "../constants/links";
import {
  convertEurToGbp,
  formatGbp,
  getEurToGbpRate,
} from "../utils/eurToGbp";

const needsGbpConversion = (plan) =>
  plan?.currency === "GBP" && Number.isFinite(Number(plan?.priceAmount));

const resolvePriceLabel = (plan, eurToGbpRate) => {
  if (needsGbpConversion(plan)) {
    if (eurToGbpRate == null) return null;
    return formatGbp(convertEurToGbp(plan.priceAmount, eurToGbpRate));
  }
  return plan.price;
};

export const Pricing = ({ data, ui }) => {
  const [eurToGbpRate, setEurToGbpRate] = useState(null);
  const shouldConvert = Boolean(data?.some(needsGbpConversion));

  useEffect(() => {
    if (!shouldConvert) return undefined;

    let cancelled = false;
    getEurToGbpRate().then((rate) => {
      if (!cancelled) setEurToGbpRate(rate);
    });

    return () => {
      cancelled = true;
    };
  }, [shouldConvert]);

  return (
    <div id="pricing" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{ui?.title}</h2>
          <p>{ui?.subtitle}</p>
        </div>
        <div className="row pricing-row">
          {data
            ? data.map((d, i) => {
                const isDownload = d.ctaAction === "download";
                const href = isDownload ? CHROME_EXTENSION_URL : "#contact";
                const ctaLabel =
                  d.cta || (isDownload ? ui?.downloadNow : ui?.getInContact);
                const ctaLabelKey = isDownload
                  ? `pricing_download_${d.name || i}`
                  : `pricing_contact_${d.name || i}`;
                const linkProps = isDownload
                  ? {
                      href,
                      target: "_blank",
                      rel: "noopener noreferrer",
                    }
                  : {
                      href,
                      className: "btn btn-custom btn-lg page-scroll",
                    };
                const priceLabel = resolvePriceLabel(d, eurToGbpRate);
                const showPeriod = Boolean(d.period && priceLabel);

                return (
                  <div key={`${d.name}-${i}`} className="col-md-6 pricing-col">
                    <div className={`pricing-card ${d.popular ? "popular" : ""}`}>
                      {d.popular && (
                        <div className="popular-badge">{ui?.mostPopular}</div>
                      )}
                      <div className="pricing-header">
                        <h3>{d.name}</h3>
                        {d.description && (
                          <p className="pricing-description">{d.description}</p>
                        )}
                        <div className="pricing-price">
                          <span
                            className={`price${!d.period ? " price-text" : ""}`}
                          >
                            {priceLabel ?? "…"}
                          </span>
                          {showPeriod && (
                            <span className="period">/{d.period}</span>
                          )}
                        </div>
                      </div>
                      <ul className="pricing-features">
                        {d.features.map((feature, idx) => (
                          <li key={idx}>
                            <i className="fa fa-check"></i>
                            {feature}
                          </li>
                        ))}
                      </ul>
                      <a
                        {...linkProps}
                        className={
                          linkProps.className || "btn btn-custom btn-lg"
                        }
                        onClick={() => trackButtonClick(ctaLabelKey)}
                      >
                        {ctaLabel}
                      </a>
                    </div>
                  </div>
                );
              })
            : ui?.loading}
        </div>
      </div>
    </div>
  );
};
